import {UpdateType} from '../../../../js/utils/const';
import {render, createElement} from '../../../../js/utils/render';
import UiModal from '../../../../js/components/UiModal/UiModal';
import {getPortfolioTemplate, getLoaderTemplate, getContentTemplate, getNextButtonTemplate} from './portfolio.template';
import { DetailsModal } from '../../../../js/components/DetailsModal/DetailsModal';

export class Portfolio extends UiModal {
  constructor(card, list, portfolioModel, blockName) {
    const template = createElement(getPortfolioTemplate())

    super(template, {
      wrapperClass: 'portfolio-v1-popup',
      isCenter: true
    });

    this._portfolioModel = portfolioModel;

    this.blockName = blockName
    this._card = card;
    this._list = list;
    this._cardId = null;
    this._isLoading = true;
    this._nextCard =  null;
    this._nextTitle = null;

    this._clickNextButtonHandler = this._clickNextButtonHandler.bind(this);
    this._onPortfolioEvent = this._onPortfolioEvent.bind(this);
    this._clickPictureHandler = this._clickPictureHandler.bind(this);

    this._popupContainer = null;
    this._loaderElement = null;
    this._contentElement = null;
    this._nextButtonElement = null;
    this._messageElement = null;
  }

  async beforeMounted() {
    this._portfolioModel.addObserver(this._onPortfolioEvent);
    this._popupContainer = this.element.querySelector('.portfolio-v1-popup__content');
    this._popupContainer.addEventListener('click', this._clickPictureHandler);

    await this._setCardData(this._card);
  }

  async _setCardData(card) {
    this._card = card;
    this._cardId = this._card.id;
    this._isLoading = !this._portfolioModel.getPortfolio(this._cardId);
    this._nextCard =  this._card.nextElementSibling || this._list.firstElementChild;
    this._nextTitle = this._nextCard
      ? this._nextCard.querySelector('.portfolio-v1__subtitle').textContent
      : null;

    this._renderLoading();
    await this._portfolioModel.loadData(this._cardId);
  }

  _onPortfolioEvent(updateType) {
    this._isLoading = false;
    this._removeElement('_loaderElement');
    this._removeElement('_contentElement');
    this._removeElement('_messageElement');
    this._removeNextButton();

    switch (updateType) {
      case UpdateType.INIT:
        this._renderContent();
        break;

      case UpdateType.ERROR:
        this._renderMessage('Похоже, произошла ошибка. Попробуйте перезагрузить страницу.');
        break;
    }
  }

  _removeElement(elementName) {
    if (this[elementName] !== null) {
      this[elementName].remove();
      this[elementName] = null;
    }
  }

  _renderLoading() {
    this._loaderElement = createElement(getLoaderTemplate());
    render(this._popupContainer, this._loaderElement);
  }

  _renderMessage(message) {
    this._messageElement = createElement(`<p class="p p--2" style="margin-top: 50px;">${message}</p>`);
    render(this._popupContainer, this._messageElement);
  }

  async _clickNextButtonHandler() {
    await this._setCardData(this._nextCard);
    this.scrollTopContent();

    window.$analytics && window.$analytics.push('portfolio-popup-next-click');
  }

  _renderNextButton(title) {
    this._nextButtonElement = createElement(getNextButtonTemplate(title));
    this._nextButtonElement.addEventListener('click', this._clickNextButtonHandler);
    render(this._popupContainer, this._nextButtonElement);
  }

  _removeNextButton() {
    if (this._nextButtonElement !== null) {
      this._nextButtonElement.removeEventListener('click', this._clickNextButtonHandler);
      this._nextButtonElement.remove();
      this._nextButtonElement = null;
    }
  }

  _renderPreviews() {
    const data = this._portfolioModel.getPortfolio(this._cardId);
    this._contentElement = createElement(getContentTemplate(data));
    render(this._popupContainer, this._contentElement);
  }

  _renderContent() {
    if (this._isLoading) {
      this._renderLoading();
      return;
    }

    this._renderPreviews();
    this._nextTitle && this._renderNextButton(this._nextTitle);
  }

  _clickPictureHandler(evt) {
    const target = evt.target.closest('[data-details="button"]');

    if (target) {
      const pictures = [];
      this._portfolioModel.getPortfolio(this._cardId).groups
        .forEach((group) => group.previews.forEach((preview => {
          pictures.push({
            media: {
              picture: {
                webp: preview.picture.origin.webp,
                img: preview.picture.origin.img,
                alt: ''
              }
            }
          });
        })));

      new DetailsModal(pictures, target.dataset.index - 1, this.blockName).init();

      window.$analytics && window.$analytics.push('portfolio-popup-picture-click');
    }
  }

  beforeUnmounted() {
    this._popupContainer.removeEventListener('click', this._clickPictureHandler);
  }
}
